import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconStickyNote = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#nc-icon-sticky-note_svg__a)">
      <path
        fill="currentColor"
        d="m21 15-6 5.996L4.002 21A1 1 0 0 1 3 20.007V3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.456.993 1.002zM19 5H5v14h8v-5a1 1 0 0 1 .883-.993L14 13l5-.001zm-.829 9.999L15 15v3.169z"
      />
    </g>
    <defs>
      <clipPath id="nc-icon-sticky-note_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </NcIcon>
);
export { NcIconStickyNote };
